!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e(require("react"), require("nouislider")) : "function" == typeof define && define.amd ? define(["react", "nouislider"], e) : (t = t || self).ReactNouislider = e(t.React, t.nouislider);
}(this, function (t, e) {
  "use strict";

  var n = "default" in t ? t.default : t;

  function r(t) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
  }

  function o(t, e, n) {
    return e in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }

  function i() {
    return (i = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = arguments[e];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }
      }

      return t;
    }).apply(this, arguments);
  }

  function u(t, e) {
    var n = Object.keys(t);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var u, c = t[Symbol.iterator](); !(r = (u = c.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0) {
          ;
        }
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  e = e && e.hasOwnProperty("default") ? e.default : e;

  var a = function a(t) {
    return Object.entries(t).sort().reduce(function (t, e) {
      var n = c(e, 2),
          r = n[0],
          o = n[1];
      return t[r] = o, t;
    }, {});
  },
      l = function l(t, e) {
    return "number" == typeof t && "number" == typeof e ? t === e : "string" == typeof t && "string" == typeof e ? t === e : Array.isArray(t) && Array.isArray(e) ? JSON.stringify(t) === JSON.stringify(e) : "object" === r(t) && "object" === r(e) && JSON.stringify(a(t)) === JSON.stringify(a(e));
  },
      f = function f(r) {
    var a = c(t.useState(null), 2),
        l = a[0],
        f = a[1],
        s = n.createRef();
    t.useEffect(function () {
      var t = r.instanceRef,
          e = t && Object.prototype.hasOwnProperty.call(t, "current");
      return t && t instanceof Function && t(s.current), e && (t.current = s.current), function () {
        e && (t.current = null);
      };
    }, [s]);

    var p = function p(t) {
      var e = Number(t.target.getAttribute("data-value"));
      l && l.set(e);
    },
        y = function y(t) {
      var e = s.current;
      e && (t ? e.setAttribute("disabled", !0) : e.removeAttribute("disabled"));
    },
        d = function d() {
      var t = r.onUpdate,
          n = r.onChange,
          i = r.onSlide,
          c = r.onStart,
          a = r.onEnd,
          l = r.onSet,
          p = e.create(s.current, function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? u(n, !0).forEach(function (e) {
            o(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(n).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }

        return t;
      }({}, r));
      c && p.on("start", c), i && p.on("slide", i), t && p.on("update", t), n && p.on("change", n), l && p.on("set", l), a && p.on("end", a), f(p);
    };

    t.useEffect(function () {
      var t = r.disabled;
      s.current && (y(t), d());
    }, []), t.useEffect(function () {
      r.clickablePips && s.current.querySelectorAll(".noUi-value").forEach(function (t) {
        t.style.cursor = "pointer", t.addEventListener("click", p);
      });
      return function () {
        var t = s.current;
        l && l.destroy(), t && t.querySelectorAll(".noUi-value").forEach(function (t) {
          t.removeEventListener("click", p);
        });
      };
    }, [l]);
    var b = r.start,
        v = r.disabled,
        m = r.range;
    t.useEffect(function () {
      l && (!function (t) {
        s.current.noUiSlider.updateOptions({
          range: t
        });
      }(m), l.set(b)), y(v);
    }, [b, v, m]);
    var g = r.id,
        O = r.className,
        S = r.style,
        h = {};
    return g && (h.id = g), O && (h.className = O), n.createElement("div", i({}, h, {
      ref: s,
      style: S
    }));
  };

  return f.defaultProps = {
    animate: !0,
    behaviour: "tap",
    className: null,
    clickablePips: !1,
    connect: !1,
    direction: "ltr",
    disabled: !1,
    format: null,
    margin: null,
    limit: null,
    keyboardSupport: !0,
    id: null,
    instanceRef: null,
    padding: 0,
    pips: null,
    snap: !1,
    step: null,
    style: null,
    orientation: "horizontal",
    tooltips: !1,
    onChange: function onChange() {},
    onEnd: function onEnd() {},
    onSet: function onSet() {},
    onSlide: function onSlide() {},
    onStart: function onStart() {},
    onUpdate: function onUpdate() {}
  }, n.memo(f, function (t, e) {
    var n = t.start,
        r = t.disabled,
        o = t.range;
    return l(e.start, n) && e.disabled === r && l(e.range, o);
  });
});